$(document).on('turbo:load', function () {
    const page = $('.admin-won-deal-submission-edit');

    page.find('.deal-select').on('change', function () {
        const selectedDealId = $(this).val();

        if (!selectedDealId) return;

        $.ajax({
            url: `/admin/won_deal_submissions/deal_quick_info`,
            method: 'GET',
            data: { deal_id: selectedDealId },
            success: function (responseHtml) {
                $('#deal-quick-info-container').html(responseHtml);
            },
            error: function () {
                $('#deal-quick-info-container').html('<div class="alert alert-danger">Failed to load deal info.</div>');
            }
        });
    });

    // Hide - show reviewed submissions section
    const reviewedSubmissionSection = $('.admin-won-deal-submissions .reviewed-submissions');
    reviewedSubmissionSection.on('click', '.reviewed-submissions__header', function () {
        const reviewedContent = reviewedSubmissionSection.find('.reviewed-submissions__content');
        const caretDown = reviewedSubmissionSection.find('.reviewed-submissions__header .fa-caret-down');
        const caretUp = reviewedSubmissionSection.find('.reviewed-submissions__header .fa-caret-up');

        if (reviewedContent.hasClass('d-none')) {
            reviewedContent.removeClass('d-none');
            // Toggle caret
            caretUp.removeClass('d-none');
            caretDown.addClass('d-none');
        } else {
            reviewedContent.addClass('d-none');
            // Toggle caret
            caretDown.removeClass('d-none');
            caretUp.addClass('d-none');
        }
    });
});

$(document).ready(function() {

  $(document).on('change', '.admin-won-deal-submission-edit .brand-select-js', function() {
    refreshCommissionCalculator({ brand_id: $(this).val() });
  });
  $(document).on('input', '.admin-won-deal-submission-edit .number-of-territories-field-js', function() {
    if (!$(this).val()) return;
    refreshCommissionCalculator({ unit_count: $(this).val() });
  });
  $(document).on('input', '.admin-won-deal-submission-edit .amount-field-js', function() {
    if (!$(this).val()) return;
    refreshCommissionCalculator({ suggested_commission: $(this).val() });
  });

  function refreshCommissionCalculator(params) {
    const commissionCalculatorComponent = $('.admin-won-deal-submission-edit .component.brands-commission-calculator-component');
    reloadComponent(commissionCalculatorComponent, params);
  }

});
